module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAS5JREFUWEftlu0NgjAQhntxEZxE2QQse6h7ANZN2EQWgfOqgEKvWiG2P7QJCZrCPbzvfRRE4AWB44s/wGIFMEkisVqdyMroZidACnleuVq7HEBKnASrP4FYBIC73Z6CHZivVVAUqYsKywCk1NInTKCaANY+AC6D9+No3gCm/g8YpICTuk6bOClf+K+3f1eBrvS0/Lb1vSR88+UcUE1/VqJpjqCUvh8tw4IuQETlddYNBbNsK9p2Q7+39KS+5i62P5gAj8ZykxGltGX6HJCK3hk/P+gCYM30GQRGcv4cQHALjPL0awFiCmWpwiUhQDw9K/hVoGnW02bkFYAbUD4B2PnwQwBMAupq8KWA0YD6UuQA+uFzH0b2g6fLKKgFoqLaP9o2zz4RuUR32fMHCK7AFUMX0CHfPzPpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zan.png
// module id = w6r0
// module chunks = 110